import React, { FC, useCallback, useMemo, useState } from 'react'

import { SVGClose } from '@common/public/assets'
import { SVGWallet } from '@common/public/assets/Wallet'
import { Button } from '@components/Button'
import useNetwork from '@hooks/useNetwork'
import useNetworkWallet from '@hooks/useNetworkWallet'
import useStoreMain from '@store/mainStore'

import {
    ButtonInventoryText,
    DotColor,
    InventoryCloseIcon,
    InventoryWallerDropdown,
    InventoryWallerMenu,
    InventoryWalletActions,
} from './index.style'

export const ButtonInventory: FC = () => {
    const { currentStep, setCurrentStep, reset: resetUseMain } = useStoreMain()
    const {
        state: { walletProvider, truncatedAddress },
        operations: { reset: resetUseNetworkWallet },
    } = useNetworkWallet()

    const {
        operations: { reset: resetUseNetwork },
    } = useNetwork()

    const [isMenuOpen, setIsMenuOpen] = useState(false)

    const handleClickInventory = useCallback(() => {
        if (!walletProvider?.connect) {
            setCurrentStep('login')
        } else {
            setCurrentStep('inventory')
        }
    }, [setCurrentStep])

    const handleClickCloseInventory = useCallback(() => {
        setIsMenuOpen(false)
        setCurrentStep('home-multiple-sales-behaviour')
    }, [setCurrentStep])

    const handleToggleWalletMenu = useCallback(() => {
        setIsMenuOpen(oldMenu => !oldMenu)
    }, [])

    const handleDisconnectInventory = useCallback(() => {
        setIsMenuOpen(false)
        resetUseMain()
        resetUseNetwork()
        resetUseNetworkWallet()
        setCurrentStep('home-multiple-sales-behaviour')
    }, [resetUseMain, resetUseNetwork, resetUseNetworkWallet, setCurrentStep])

    console.log('[currentStep]', currentStep)

    const isInInventory = useMemo(
        () => ['login', 'inventory', 'inventory-useWinter'].includes(currentStep),
        [currentStep],
    )
    const shouldAppearWalletMenu = useMemo(
        () => ['inventory', 'inventory-useWinter'].includes(currentStep),
        [currentStep],
    )

    if (isInInventory)
        return (
            <InventoryWalletActions>
                {shouldAppearWalletMenu && (
                    <InventoryWallerDropdown>
                        <Button onClick={handleToggleWalletMenu}>
                            <SVGWallet /> Wallet
                        </Button>
                        <InventoryWallerMenu menuOpen={isMenuOpen}>
                            <div>
                                <div>Metamask</div>
                                <InventoryCloseIcon onClick={handleToggleWalletMenu}>
                                    <SVGClose />
                                </InventoryCloseIcon>
                            </div>
                            <div>
                                <div>{truncatedAddress}</div>
                                <DotColor />
                            </div>
                            <div>
                                <Button fullWidth color="danger" onClick={handleDisconnectInventory}>
                                    Disconnect
                                </Button>
                            </div>
                        </InventoryWallerMenu>
                    </InventoryWallerDropdown>
                )}
                <Button color="secondary" onClick={handleClickCloseInventory}>
                    <SVGClose fill="#fff" />
                </Button>
            </InventoryWalletActions>
        )

    return (
        <Button onClick={handleClickInventory}>
            <ButtonInventoryText>Inventory </ButtonInventoryText>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-briefcase"
            >
                <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
            </svg>
        </Button>
    )
}
